import ModelFactory from 'business/models/ModelFactory';
import { DewarClient, DewarDTO } from 'business/models/Models';
import BaseService from './BaseService';

export default class DewarService extends BaseService {
  async getAllDewars(): Promise<DewarDTO[]> {
    const _dewarService: DewarClient = ModelFactory(DewarClient);
    return await _dewarService.getAllDewars();
  }
}
